import { PaginationModeCursor } from './PaginationModeCursor';
import { PaginationModeOffset } from './PaginationModeOffset';
import { CollectionState } from './CollectionState';
import { FiltersMap } from '../model';

export type PaginationModeRef = {
  current: 'offset' | 'cursor' | undefined;
};

export class PaginationMode<T, F extends FiltersMap = FiltersMap> {
  readonly collection: CollectionState<T, F>;
  readonly cursorMode: PaginationModeCursor<T, F>;
  readonly offsetMode: PaginationModeOffset<T, F>;

  constructor(collection: CollectionState<T, F>) {
    this.collection = collection;
    this.cursorMode = new PaginationModeCursor({ collection });
    this.offsetMode = new PaginationModeOffset({ collection });
  }

  get mode(): PaginationModeCursor<T, F> | PaginationModeOffset<T, F> {
    return this.collection._paginationModeRef.current === 'cursor'
      ? this.cursorMode
      : this.offsetMode;
  }

  get fetchedLastPage() {
    return this.mode.fetchedLastPage;
  }

  setCursor(cursor: string | null) {
    this.mode.setCursor(cursor);
  }

  get id() {
    return this.mode.id;
  }
}
